<script setup>
  import { computed, inject } from 'vue'
  import { Recycle } from '@vicons/fa'
  import { NIcon, NPopover } from 'naive-ui'

  const appStoreFn = inject('appStoreFn')
  const appStore = appStoreFn()
  const rtlsTitle = computed(() => `RTLS Connection ${appStore.stompStatusOptions.isConnected ? 'Active' : 'Lost'}`)
  const rtlsIconColor = computed(() => (appStore.stompStatusOptions.isConnected ? 'green' : 'red'))
</script>
<template>
  <NPopover trigger="hover">
    <template #trigger>
      <NIcon :color="rtlsIconColor"><Recycle /></NIcon>
    </template>
    <span>
      <NIcon><Recycle :color="rtlsIconColor" /></NIcon>
      {{ rtlsTitle }}
    </span>
  </NPopover>
</template>
